import React from "react";
import svg62 from "../../../assets/svg/svg62.svg";
import { useSelector } from "react-redux";

function HarvestingCard() {
  const url = "api/v2/dashboard/getProjectDashboardData";
  const { loading, count, data } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));

  return (
    <div className="p-[1.25rem] rounded-[.75rem] bg-white w-full h-full">
      <div className="flex items-center gap-x-[.65rem]">
        <span className="">Projects type</span>
        <img src={svg62} alt="svg62" />
      </div>
      <div className="flex flex-shrink flex-wrap items-start gap-y-[3.25rem] gap-x-[1rem] w-full mt-[2rem]">
        {data?.projectType &&
          data?.projectType?.map((item, index) => (
            <>
              <div key={index} className="flex-1 w-full">
                <div className="text-[#050505] text-[.875rem] font-[400] font-roboto  whitespace-nowrap">
                  {item?.name}
                </div>
                <div className="mt-[2rem] flex justify-between items-center">
                  <span className="text-[#050505] font-interSans text-[1.5rem] font-[500]">
                    {item?.value}
                  </span>
                </div>
              </div>
              {index !== data?.projectType?.length - 1 && (
                <span className="lg:h-[5rem] h-0 lg:w-0 w-full lg:border-l border-b border-[#D6E1F5] lg:mx-[2.2rem] "></span>
              )}
            </>
          ))}
      </div>
    </div>
  );
}

export default HarvestingCard;
